/**
 * Animation/timeline constants shared across the playback store and the
 * timeline UI.
 */

/**
 * Timeline length (seconds) shown for an ad with no timed, animated or
 * media content. The lane needs a nonzero span so ghost bars stay
 * grabbable — dragging one is how a layer's timing gets pinned. It is also
 * the shortest clock of a design timed only by its animation blocks (no
 * layer window, no media), so its untimed layers keep room for an entrance
 * and an exit. Otherwise the real content end drives the lane and the clock.
 */
export const DEFAULT_TIMELINE_SECONDS = 5;

/**
 * The timeline panel floats over the bottom of the canvas area: this tall,
 * this far above its bottom edge. The canvas fit leaves that strip out.
 */
export const TIMELINE_PANEL_HEIGHT = 280;
export const TIMELINE_PANEL_INSET = 12;

/**
 * Drag payload type for a timeline track row being reordered. Its own type,
 * never `text/plain`, so the editor's media drop handler ignores it.
 */
export const TIMELINE_TRACK_DRAG_MIME = 'application/x-stunnr-timeline-track';

/**
 * Smallest scale animation presets may use. A true zero creates a zero-size
 * Fabric cache canvas and can make exact-frame export fail at tween bounds.
 */
export const MIN_ANIMATION_SCALE = 0.0001;

/** Unit vectors pointing from an object toward each canvas edge. */
export const ANIMATION_SIDE_VECTORS: Record<string, { x: number; y: number }> =
  {
    left: { x: -1, y: 0 },
    right: { x: 1, y: 0 },
    top: { x: 0, y: -1 },
    bottom: { x: 0, y: 1 }
  };

/** Focus point to pan direction for Ken Burns media animation. */
export const KEN_BURNS_FOCUS_OFFSETS: Record<string, { x: number; y: number }> =
  {
    center: { x: 0, y: 0 },
    topLeft: { x: -1, y: -1 },
    topRight: { x: 1, y: -1 },
    bottomLeft: { x: -1, y: 1 },
    bottomRight: { x: 1, y: 1 }
  };

/** Fixed MotionPathPlugin tension; bend remains the user-facing shape knob. */
export const MOTION_PATH_CURVINESS = 1.25;

export const loopTypes = {
  once: 1,
  forever: 100
};
export const defaultFPS = 30;
